import { TFunction } from 'i18next';
import { AdStatus } from '@/types';

export const tabs = (t: TFunction): { name: string; value: AdStatus }[] => [
  { name: t('pages.cabinet.published'), value: AdStatus.Published },
  {
    name: t('pages.cabinet.awaiting_payment'),
    value: AdStatus.AwaitingPayment,
  },
  { name: t('pages.cabinet.limit'), value: AdStatus.Expired },
  { name: t('pages.cabinet.pending'), value: AdStatus.Pending },
  { name: t('pages.cabinet.rejected'), value: AdStatus.Rejected },
  { name: t('pages.cabinet.archived'), value: AdStatus.Archived },
];
